import { render, staticRenderFns } from "./tool.vue?vue&type=template&id=61c97fff&scoped=true"
import script from "./tool.vue?vue&type=script&lang=js"
export * from "./tool.vue?vue&type=script&lang=js"
import style0 from "./tool.vue?vue&type=style&index=0&id=61c97fff&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c97fff",
  null
  
)

export default component.exports